import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

class CellarLocation extends React.Component {
  directionsAddress() {
    const { coords } = this.props

    return 'https://www.google.com/maps/dir/Current+Location/' +
           `${coords.latitude},${coords.longitude}`
  }

  render() {
    return (
      <a
        className="location-box__content__link"
        href={this.directionsAddress()}
        target="_blank" rel="noreferrer"
      >
        <FormattedMessage id="app.cellar.location.directions" />
        <i className="icon--arrow-right"></i>
      </a>
    )
  }
}

CellarLocation.propTypes = {
  coords: PropTypes.object.isRequired,
}

export default CellarLocation
